import React from "react";
import st from './index.scss'

export default function FastForwardFastBack({ player }){
    // 快进
    function fastForward(){
        var currentTime = player.currentTime()
        player.currentTime(currentTime + 15)
        // console.log('快进到',currentTime + 15)
    }

    // 快退
    function fastBack(){
        var currentTime = player.currentTime()
        player.currentTime(currentTime - 15)
        // console.log('快退到',currentTime - 15)
    }

    return <div className={st['video-speed']}>
        <span className={st['fast-back']} onClick={fastBack}>快退15s</span>
        <span className={st['fast-forward']} onClick={fastForward}>快进15s</span>
    </div>
}   